import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ConfirmDialogComponent } from '@ebeihilfe/web-logic';
import { LogoSvgComponent } from '@ebeihilfe/web-shared/web-svgs/logo/logo.component';
import { TutorialSvgComponent } from '@ebeihilfe/web-shared/web-svgs/tutorial/tutorial.component';
import { TranslateModule } from '@ngx-translate/core';

import { CustomDateAdapter } from './CustomDateAdapter';
import { ToI18nKeyPipe } from './footer/footer-list/to-i18n-key/to-i18n-key.pipe';
import { IconWithTextComponent } from './icon-with-text/icon-with-text.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { OldBrowserWarningComponent } from './old-browser-warning/old-browser-warning.component';
import { PortalPagComponent } from './portal-page/portal-page.component';
import { ResponsiveFilterPipe } from './portal-toolbar/responsive-filter/responsive-filter.pipe';
import { TutorialComponent } from './tutorial/tutorial.component';

const components = [IconWithTextComponent, OldBrowserWarningComponent, PortalPagComponent, TutorialComponent];

@NgModule({
  imports: [
    A11yModule,
    CommonModule,
    ConfirmDialogComponent,
    FormsModule,
    LoginFormComponent,
    LogoSvgComponent,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatToolbarModule,
    MatTooltipModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    TutorialSvgComponent,
    ResponsiveFilterPipe,
    ToI18nKeyPipe,
  ],
  declarations: [components],
  exports: [...components],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
  ],
}) // TODO: Rename module or filenames
export class CustomComponentModule {}
